import React from 'react';
import AddEditCustomerForm from 'ui-component/AddEditCustomerForm';


function EditCustomer() {
  return (
    <div>
      <AddEditCustomerForm title="Edit Customer" />
    </div>
  );
}

export default EditCustomer;
